import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useCallback, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import QueryParamProxy from '../../../utils/queryParamProxy';
import RouteParamConstants from '../../../utils/routeParamConstants';
import { ACTION_COMMANDS_TYPE, ACTION_COMMANDS_MODAL_TYPE } from '../../../api/ActionCommandsInterface/constants';
import Emitter from '../../../services/EmitterService';
import { EVENT_EMITTER_TYPE } from '../../../constants';
import Screens from '../..';
import { setModal } from '../../../state/actions/modal';
import { sendLTOEvent } from '../analytics/ltoLogger.js';
import { LTO_EVENT_TYPES } from '../constants/events';
function useCheckCloseLTOConfirmation() {
  var _actionCommands$modal;
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      var _state$consumables$lt;
      return {
        ltoOfferEndTime: (_state$consumables$lt = state.consumables.ltoOffer) === null || _state$consumables$lt === void 0 ? void 0 : _state$consumables$lt.OFFER_END_TIME,
        actionCommands: state.actionCommands.actions.find(function (action) {
          var _action$payload;
          return (action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.screen) === Screens.Home;
        })
      };
    }, shallowEqual),
    ltoOfferEndTime = _useSelector.ltoOfferEndTime,
    actionCommands = _useSelector.actionCommands;
  var checkLTOTimer = useRef();
  var clickedButton = useRef(false);
  var closedByTime = useRef(false);
  var actionUUID = actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.uuid;
  var isLTOActionCommand = actionUUID && (actionCommands === null || actionCommands === void 0 || (_actionCommands$modal = actionCommands.modal) === null || _actionCommands$modal === void 0 ? void 0 : _actionCommands$modal.modalType) === ACTION_COMMANDS_MODAL_TYPE.LIMTED_TIME_OFFER;
  var removeAction = useCallback(function () {
    if (isLTOActionCommand) {
      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND,
        data: {
          uuid: actionUUID
        }
      });
    }
  }, [actionUUID, isLTOActionCommand]);
  var dismissModal = useCallback(function () {
    clickedButton.current = true;
    QueryParamProxy.dismissModal();
    sendLTOEvent(LTO_EVENT_TYPES.DISMISS_LTO_CONFIRMATION_SCREEN);
    removeAction();
  }, [removeAction]);
  var goBackToLTO = function goBackToLTO() {
    clickedButton.current = true;
    sendLTOEvent(LTO_EVENT_TYPES.ACCEPT_LTO_CONFIRMATION_SCREEN);
    QueryParamProxy.dismissModal();
    QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LimitedTimeOffer));
    dispatch(setModal(Screens.LimitedTimeOffer));
  };
  useEffect(function () {
    if (!ltoOfferEndTime) {
      closedByTime.current = true;
      QueryParamProxy.dismissModal();
      removeAction();
      return;
    }
    var now = Date.now();
    var delay = Math.max(ltoOfferEndTime - now, 0);
    checkLTOTimer.current = setTimeout(function () {
      closedByTime.current = true;
      QueryParamProxy.dismissModal();
      removeAction();
    }, delay);
    return function () {
      clearTimeout(checkLTOTimer.current);
    };
  }, [ltoOfferEndTime, dismissModal]);
  useEffect(function () {
    return function () {
      if (!clickedButton.current && !closedByTime.current) {
        removeAction();
        sendLTOEvent(LTO_EVENT_TYPES.DISMISS_LTO_CONFIRMATION_SCREEN);
      }
    };
  }, [removeAction]);
  return {
    dismissModal: dismissModal,
    goBackToLTO: goBackToLTO
  };
}
export default useCheckCloseLTOConfirmation;